<div class="cookie-overlay" *ngIf="showBanner"></div>
<div class="cookie-consent" *ngIf="showBanner">
  <div class="cookie-content">
    <div class="cookie-icon">
      <i class="fa fa-cookie-bite"></i>
    </div>
    <div class="cookie-text">
      <h4>{{ 'cookieConsent.title' | translate }}</h4>
      <p>{{ 'cookieConsent.description' | translate }}</p>
      <a routerLink="/cookie-policy" class="cookie-link">{{ 'cookieConsent.readPolicy' | translate }}</a>
    </div>
    <div class="cookie-actions">
      <button class="btn-accept-all" (click)="acceptAll()">{{ 'cookieConsent.acceptAll' | translate }}</button>
      <button class="btn-necessary" (click)="acceptNecessary()">{{ 'cookieConsent.necessaryOnly' | translate }}</button>
    </div>
  </div>
</div>
